module.exports = __webpack_public_path__ + "static/media/semicolon-spammer-1.d19607fa.gif";